export const RESET_FEATURES = "RESET_FEATURES";
export const RESET_FEATURE = "RESET_FEATURE";
export const RESET_ERROR = "FEATURES_RESET_ERROR";

export const GET_FEATURES = "GET_FEATURES";
export const SET_FEATURES = "SET_FEATURES";

export const API_ERROR = "FEATURES_API_ERROR";

export const GET_FEATURE = "GET_FEATURE";
export const SET_FEATURE = "SET_FEATURE";

export const EDIT_FEATURE = "EDIT_FEATURE";
export const EDIT_FEATURE_SUCCESS = "EDIT_FEATURE_SUCCESS";

export const CREATE_FEATURE = "CREATE_FEATURE";
export const CREATE_FEATURE_SUCCESS = "CREATE_FEATURE_SUCCESS";

export const DELETE_FEATURE = "DELETE_FEATURE";
export const DELETE_FEATURE_SUCCESS = "DELETE_FEATURE_SUCCESS";
